<template>
  <div class="centering_with_gap flex rem-padding-right">
    <div
      v-if="presentDates"
      @click="openSettings"
      class="centering_with_gap flex clikable">
      <div class="field">
        <img
         :src="require('@/assets/images/calendar_icon.png')"
         width="21px"
         height="24px"
         alt=""
        >
      </div>
      <div class="field">
        <i class="calendar icon"></i>
        <span class="main_ride_dates">{{ride.start_date}}</span>
      </div>
      <img
        :src="require('@/assets/images/arrow-right-solid.png')"
        alt=""
        width="18px"
        height="20px"
      >
      <div class="field">
        <i class="calendar icon"></i>
        <span class="main_ride_dates">{{ride.end_date}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

// The trip's start → end dates. The author can click them to open the ride
// settings.
export default {
  name: 'RideDates',
  props: {
    ride: { type: Object, required: true },
  },
  data() {
    return {
      presentDates: true,
    };
  },
  computed: {
    ...mapGetters(['allRide', 'compareToUserId']),
  },
  watch: {
    allRide: {
      handler() {
        this.refreshPresentDates();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['shouldPresentTheDates', 'openRideInformationPage']),
    async refreshPresentDates() {
      // shouldPresentTheDates reads allRide.ride: wait for the ride to load.
      if (!this.allRide || !this.allRide.ride) return;
      this.presentDates = await this.shouldPresentTheDates();
    },
    openSettings() {
      if (this.compareToUserId(this.ride.authorId))
        this.openRideInformationPage(this.ride.id);
    },
  },
};
</script>

<style scoped>
.clikable {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 10px 20px;
  text-align: center;
}

.clikable:hover {
  transform: scale(1.02);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}
</style>
